import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-reports',
  templateUrl: './risk-reports.component.html',
  styleUrls: ['./risk-reports.component.css']
})
export class RiskReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
